export enum FactoryMoveRequestStatus {
    Open = 'Open',
    Completed = 'Completed',
    Canceled = 'Canceled',
}
